import { Children, createElement, useCallback, useEffect, useRef, useState } from 'react';
import { omit } from '../../../utils';
import * as AdminModalTypes from '../constants/AdminModalTypes';
import { TEAM } from '../constants/AdminTypes';
import { getIsAdmin } from '../eligibility/getIsAdmin';
import AdminModal from './AdminModal';
// @ts-expect-error upstream is not migrated to TypeScript
import UpgradeProductToApiNameMap from 'self-service-api/constants/UpgradeProductToApiNameMap';
import { logRavenException } from '../../utils/errors';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AdminOnlyWrapper = ({
  modalType = AdminModalTypes.DEFAULT,
  productLine,
  upgradeData,
  adminType = TEAM,
  onClick,
  children
}) => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [showAdminModal, setShowAdminModal] = useState(false);
  const _isMounted = useRef(true);

  // TO DO: This is the only remaining instance of correctedUpgradeData because
  // purchase motions are wrapped by this component and received the adjusted
  // apiName. This can happen when the `AdminOnlyWrapper` (via the purchase
  // motion) is called outside of growth-mon owned applications
  const correctedUpgradeData = Object.assign({}, upgradeData, {
    apiName: upgradeData.apiName || UpgradeProductToApiNameMap[upgradeData.upgradeProduct]
  });
  useEffect(() => {
    void getIsAdmin(adminType).then(isAdminResponse => {
      if (_isMounted.current) {
        setIsAdmin(isAdminResponse);
      }
    });
  }, [adminType]);
  useEffect(() => {
    if (modalType === AdminModalTypes.REQUEST_QUOTE && !productLine) {
      logRavenException({
        customMessage: 'Error in AdminOnlyWrapper: missing productLine for modalType REQUEST_QUOTE',
        error: Error('Error in AdminOnlyWrapper: missing productLine for modalType REQUEST_QUOTE')
      });
    }
    return function cleanup() {
      _isMounted.current = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleToggleAdminModal = useCallback(() => {
    if (onClick) onClick();
    setShowAdminModal(!showAdminModal);
  }, [onClick, showAdminModal]);
  const child = Children.only(children);
  if (isAdmin) {
    return child;
  }
  const newProps = omit(Object.assign({}, child.props, {
    onClick: handleToggleAdminModal
  }), 'href');
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [showAdminModal && /*#__PURE__*/_jsx(AdminModal, {
      modalType: modalType,
      onClose: handleToggleAdminModal,
      productLine: modalType === AdminModalTypes.REQUEST_QUOTE ? productLine : undefined,
      upgradeData: correctedUpgradeData
    }), /*#__PURE__*/createElement(child.type, newProps)]
  });
};
export default AdminOnlyWrapper;